module.exports = __webpack_public_path__ + "img/mark-white.cb73d45f.svg";